import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Tooltip, Whisper } from "rsuite";

type ProgressProps = {
  progress: number;
  progressColor: string;
  completeColor: string;
  totalWidth: number;
  textColor: string;
  totalCardCount: number;
};

const CustomProgress = (props: ProgressProps) => {
  console.log("width", props.totalWidth);
  console.log("progressColor", props.progressColor);
  console.log("complete color", props.completeColor);

  const { progress } = props;
  const { totalWidth } = props;
  const { textColor } = props;
  const { totalCardCount } = props;
  const notAck = totalCardCount - progress;

  const tooltip = (
    <Tooltip className="bg-mk-primary text-black">
      <div>
        {/* Acknowledged= {progress} */}
        <FormattedMessage id="analytics.summaryDisplay.acknowledged"></FormattedMessage>{" "}
        = {progress}
      </div>
      <div>
        {/* Not Acknowledged={notAck} */}
        <FormattedMessage id="analytics.summaryDisplay.notAcknowledged"></FormattedMessage>{" "}
        = {notAck}
      </div>
    </Tooltip>
  );

  const handleChildTooltipClick = (e: any) => {
    e.stopPropagtion();
  };

  console.log("not ack", notAck);

  const ackProgress = (progress / totalCardCount) * 100;

  console.log("progress", progress);
  console.log("totalCardCount", totalCardCount);
  console.log("text color", textColor);

  return (
    // opacity-0 hover:opacity-100

    <div>
      <Whisper
        placement="top"
        controlId="control-id-hover"
        trigger="hover"
        speaker={tooltip}
      >
        <div
          className={`h-3 relative rounded-full hover:text-black text-center text-xs transition-all duration-300`}
          style={{
            width: `${totalWidth}%`,
            backgroundColor: `${props.completeColor}`,
          }}
        >

          <div
            className={`h-full rounded-full ${props.progressColor}`}
            style={{
              width: `${ackProgress}%`,
              backgroundColor: `${props.progressColor}`,
            }}
          >
            <div className="flex">
              <div
                className="font-bold  text-xs transition-all duration-300 opacity-0 hover:opacity-100 text-center
              "
                onClick={handleChildTooltipClick}
              >
              </div>

              <div
                className={`font-bold text-center text-xs transition-all duration-300 opacity-0 hover:opacity-100 ml-[-${props.progressColor}%]`}
              >
              </div>
            </div>
          </div>
        </div>
      </Whisper>
    </div>
  );
};

export default CustomProgress;
